import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  getPyqTopicWiseSetsRequest,
  setSelectedSetId,
  setTestDetails,
  setTestType,
  // setPaperId, // ✅ ADDED
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWiseSet.css";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";

const PyqTopicWiseSet = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { pyqTopicWiseSets, activeSubject, selectedTopic, plannerDetails } =
    useSelector((state) => state.examSlice);

  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
  } = plannerDetails || {};

  useEffect(() => {
    if (activeSubject && selectedTopic?.topic_name) {
      dispatch(
        getPyqTopicWiseSetsRequest({
          subject: activeSubject,
          topic: selectedTopic.topic_name,
        })
      );
    }
  }, [dispatch, activeSubject, selectedTopic]);

  // ✅ FIXED HANDLER (paperId added, nothing removed)
 const handleFooterClick = (set) => {
  const paperId = set.paper_id || set.test_id || set.set_id;
  const testId  = set.test_id || set.set_id;

  dispatch(setSelectedSetId(set.set_id));
  dispatch(setTestType({ id: paperType }));

  const payload = {
    paperId,           
    testId,            
    paperType,
    plannerId: planner_id,
    categoryId: category_id || "",
    setId: set.set_id,
  };

  dispatch(setTestDetails(payload));
  dispatch(fetchExamInstructionRequest(payload));

  history.push("/TestInstruction");
};

  if (!pyqTopicWiseSets?.sets?.length) {
    return <div className="loading">Loading sets...</div>;
  }

  const getButton = (set) => {
    const isLocked = set.is_subscribed === 0;
    const isStarted = set.attempted_questions > 0;
    const isCompleted =
      set.progress_percentage === 100 ||
      set.attempted_questions === set.total_questions;

    if (isLocked) {
      return (
        <button
          className="practice-btn locked-btn"
          disabled
          onClick={() => history.push(`/store/${set.package_id}`)}
        >
          Locked
        </button>
      );
    }

    if (isCompleted) {
      return (
        <button
          className="practice-btn reattempt-btn"
          onClick={() => handleFooterClick(set)}
        >
          Reattempt
        </button>
      );
    }

    if (isStarted) {
      return (
        <button
          className="practice-btn resume-btn"
          onClick={() => handleFooterClick(set)}
        >
          Resume
        </button>
      );
    }

    return (
      <button
        className="practice-btn start-btn"
        onClick={() => handleFooterClick(set)}
      >
        Start Test
      </button>
    );
  };

  return (
    <>
      <div className="topic-wise-header">
        <img
          style={{ width: "24px", height: "24px", cursor: "pointer" }}
          src={images.new_backarrow}
          alt="Back"
          onClick={() => history.goBack()}
        />
        <h3>Topic Wise Set</h3>
      </div>

      <div className="container">
        <div className="wrapper">
          <div className="grid">
            {pyqTopicWiseSets.sets.map((set) => (
              <div key={set.set_id} className="card-pyq">
                <div className="card-header">
                  <div className="circle">⚡</div>

                  <div className="card-info">
                    <h3 className="set-name">{set.set_name}</h3>
                    <p className="set-details">
                      {set.total_questions} Questions ({set.year_range})
                    </p>
                  </div>
                </div>

                <div className="card-footer">{getButton(set)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PyqTopicWiseSet;
